import { createRouter, createWebHistory } from 'vue-router'

import HomePage from "@/components/HomePage.vue";
import ErrorPage from "@/components/ErrorPage.vue";
import BudgetDraft from '@/components/budget/BudgetDraft.vue'
import ForbiddenPage from '@/components/ForbiddenPage.vue'
import NotFoundPage from '@/components/NotFoundPage.vue'
import ServerErrorPage from '@/components/ServerErrorPage.vue'

const router = createRouter({
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/budget/draft",
      name: "BudgetDraft",
      component: BudgetDraft
    },
    {
      path: "/budget/draft/:lkid",
      name: "BudgetDraftLK",
      component: HomePage
    },
    {
      path: "/error",
      name: "ErrorPage",
      component: ErrorPage
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorPage
    },
    {
      path: "/403",
      name: "ForbiddenPage",
      component: ForbiddenPage
    },
    {
      path: "/404",
      name: "NotFoundPage",
      component: NotFoundPage
    },
    {
      path: "/500",
      name: "ServerErrorPage",
      component: ServerErrorPage
    },
  ],
  history: createWebHistory()
});
const DEFAULT_TITLE = 'ФРП';
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  next();
});
export default router;
